function formatPercent(value) {
  return value === null || value === undefined ? "—" : `${Number(value).toFixed(2)}%`;
}

function formatCount(value) {
  return value === null || value === undefined ? "—" : Number(value).toLocaleString();
}

function Metric({ label, value, tone = "text-slate-700" }) {
  return (
    <div className="rounded-lg bg-white px-2 py-2">
      <p className="text-[9px] font-bold uppercase tracking-wider text-slate-400">
        {label}
      </p>
      <p className={`mt-0.5 text-sm font-black tabular-nums ${tone}`}>{value}</p>
    </div>
  );
}

export default function CarrierReportPanel({ report }) {
  if (!report) return null;

  const unknownCategories = Array.isArray(report.unknown_categories)
    ? report.unknown_categories
    : [];
  const missingActualDelivery = Number(report.missing_actual_delivery_count ?? 0) || 0;

  return (
    <div className="mt-3 rounded-xl border border-violet-200 bg-violet-50/50 p-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-[10px] font-bold uppercase tracking-widest text-violet-700">
          Carrier report
        </p>
        {report.period && (
          <span className="text-xs font-semibold text-violet-700">{report.period}</span>
        )}
      </div>

      {report.account && <p className="mt-1 text-xs text-slate-600">{report.account}</p>}

      <div className="mt-3 grid grid-cols-3 gap-2 text-center">
        <Metric label="Measured" value={formatCount(report.total_measured)} />
        <Metric label="On Time" value={formatCount(report.total_on_time)} />
        <Metric label="Exceptions" value={formatCount(report.total_exceptions)} />
      </div>

      <div className="mt-2 grid grid-cols-2 gap-2 text-center">
        <Metric
          label="Carrier cleansed"
          value={formatPercent(report.tnt_performance)}
          tone="text-violet-700"
        />
        <Metric
          label="Overall"
          value={formatPercent(report.overall_performance)}
          tone="text-violet-700"
        />
      </div>

      {missingActualDelivery > 0 && (
        <p className="mt-2 rounded-lg bg-slate-100 px-2.5 py-1.5 text-[11px] text-slate-600">
          {missingActualDelivery} row(s) have no Actual Delivery — the existing Machship
          completed date is left untouched.
        </p>
      )}

      {unknownCategories.length > 0 && (
        <p className="mt-2 rounded-lg bg-amber-50 px-2.5 py-1.5 text-[11px] text-amber-700 ring-1 ring-amber-200">
          Unrecognised category treated as a miss: {unknownCategories.join(", ")}
        </p>
      )}
    </div>
  );
}
